var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKenya(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ad2317",
    d: "M0 9h30v6H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M30 7H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2b6519",
    d: "M30 24H0v-7h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 7h30v2H0zm0 8h30v2H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.35 7.1c.53-.93.76-1.76.87-2.3l.03-.17-.14.12a7 7 0 0 0-1.54 1.9c-.2.33-.4.67-.3 1.04L15 11.6l-2.26-3.9c.09-.37-.11-.71-.3-1.04a7 7 0 0 0-1.55-1.9l-.14-.12.04.18q.24 1.21.87 2.29c.19.33.39.67.75.78l2.37 4.1-3.54 6.13.34.2L15 12.37l3.43 5.94.33-.2L15.23 12l2.37-4.11c.36-.11.56-.45.75-.78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad2317",
    d: "M16.23 7.08a7 7 0 0 0-1.02-.96.35.35 0 0 0-.42 0q-.52.38-1.02.96a8 8 0 0 0-1.85 4.98 7.5 7.5 0 0 0 2.82 5.9.4.4 0 0 0 .53 0 7 7 0 0 0 1.2-1.23 8 8 0 0 0 1.61-4.67 8 8 0 0 0-1.85-4.98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.53 14.97a5.1 5.1 0 0 0 0-5.95 9 9 0 0 0-.61 2.97c.01.61.11 1.75.61 2.98m4.94 0a5.1 5.1 0 0 1 0-5.95q.57 1.43.61 2.97a9 9 0 0 1-.61 2.98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 6a6.5 6.5 0 0 0 0 5 6.5 6.5 0 0 0 0-5m0 7a6.5 6.5 0 0 0 0 5 6.5 6.5 0 0 0 0-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenya);
export default __webpack_public_path__ + "static/media/kenya.c7379358061d26807e7b16520a92ecdf.svg";
export { ForwardRef as ReactComponent };